import {createLogger} from "../../common/logging.config";

const template = require('./downloadSite.html');
require('./downloadSite.scss');

const logger = createLogger('download-site');
//var logger = require('../../common/logging.config');


class downloadAssetsController {

	constructor($scope, downloadInfoService, $translate, homepageUtil, tenantRegistryService, x1Modal, shellUtil) {
	    this.$translate = $translate;
	    this.homepageUtil = homepageUtil;
	    this.shellUtil = shellUtil;
	    this.downloadInfoService = downloadInfoService;
        this.modal = x1Modal;
        this.$scope = $scope;

        $scope.OsloDate = 'N/A';
        $scope.StockholmDate = 'N/A';
        $scope.installedSampleName = 'N/A';
        $scope.showInstalledBuildDate = false;
        $scope.showLatestAvailableBuildDate = false;
        $scope.showLatestStockholmDate = false;
        $scope.showInstalledSample = false;


        $scope.showDownloadStockholm = false;
        $scope.getDownloadStockholmInfo = false;
        $scope.stockholmToggleOn = shellUtil.isToggleOn('downloadStockholm');
        $scope.importSiteToggleOn = shellUtil.isToggleOn('importSite');


        // Get Latest Stockholm available date. Called only downloadStockholm or importSite toggle is on
        if ($scope.stockholmToggleOn || $scope.importSiteToggleOn){
            //get Latest Stockholm update date
            downloadInfoService.getDownloadInfo('stockholm').then(
                (data) => {
                    logger.info("Got Stockholm Date - " + data.Date);
                    let date = new Date( (data.NewVersion !== undefined) ? data.NewVersion : data.Date );
                    $scope.getDownloadStockholmInfo = true;

                    //Don't show donwload stockholm in this case;
                    if (data.isCommerce === false ){
                        $scope.showDownloadStockholm = false;
                        return null;
                    }
                    else  {
                        $scope.showDownloadStockholm = true;
                        // Triggered when API fails
                        if ( !date || date.toDateString() === "Invalid Date")
                        {
                            $scope.StockholmDate = this.$translate.instant("Unavailable");
                            $scope.showLatestStockholmDate = false;
                            return $scope.StockholmDate;
                        }
                        $scope.showLatestStockholmDate = true;
                        $scope.StockholmDate = this._getLocaleDateString(date);
                        return $scope.StockholmDate;
                    }

                },
                (error) => {
                    logger.error('Error retrieving date of downloadable Stockholm templates: ' + error);
                    $scope.getDownloadStockholmInfo = true;
                    return [];
                }
            );
        }


        //Get Latest SPA available date
        downloadInfoService.getDownloadInfo().then(
            (data) => {
                logger.info("Got Oslo Date - " + data.NewVersion);
                let date = new Date( (data.NewVersion !== undefined) ? data.NewVersion : data.Date );

                // Triggered when API fails
                if ( !date || date.toDateString() === "Invalid Date")
                {
                    $scope.OsloDate = this.$translate.instant("Unavailable");
                    $scope.showLatestAvailableBuildDate = false;
                    return $scope.OsloDate;
                }
                $scope.showLatestAvailableBuildDate = true;
                $scope.OsloDate = this._getLocaleDateString(date);
                return $scope.OsloDate;
            },
            (error) => {
                logger.error('Error retrieving date of downloadable Oslo templates: ' + error);
                return [];
            }
        );

        // Get installed build date
        tenantRegistryService.getTenantInformation().then(
                (tenantData) => {
                    // If the tenant has a custom hostname(ch), then use the custom one, or use the hostname(h)
                    const domain_name = JSON.parse(tenantData.edgeToken)["ch"] ? JSON.parse(tenantData.edgeToken)["ch"] : JSON.parse(tenantData.edgeToken)["h"];
                    logger.info('Domain name used:' + domain_name);

                    this.getSiteBuildDate(domain_name, tenantData.id);
                },
                (error) => {
                    logger.error('Error retrieving tenant id info from server: ' + error.Error);
                }
            );
    }

    // Get installed SPA build date by reading buildDate.json in Developer Assets
    getSiteBuildDate(domain_name, tenant_ID){
        return this.downloadInfoService.getSiteBuildDate(domain_name, tenant_ID).then(
            (data) => {
                logger.info("Installed sample build Date - " + data.buildDate);
                let site_name = data.name;
                let date = new Date(data.buildDate);

                // Triggered when build Date is not available
                if ( !data.buildDate || !date || date.toDateString() === "Invalid Date")
                {
                    this.$scope.showInstalledBuildDate = false;
                    return false;
                }
                this.$scope.installedSampleName = (site_name === undefined) ? 'N/A' : site_name;
                this.$scope.showInstalledSample = true;

                this.$scope.showInstalledBuildDate = true;
                this.$scope.buildDate = this._getLocaleDateString(date);
                return true;
            },
            (error) => {
                logger.info('Error retrieving build date of downloadable Oslo templates: ' + error);
                return false;
            }
        );
    }


    // Download SPA sample 
	getDownload(template_name) {
	    this.shellUtil.bindAnalytics("e", "WCH Widget Sample Site Download", "WCH Widgets");
        var xhr = new XMLHttpRequest();
        const url =  (template_name === undefined) 
                    ? '/api/infra/v1/download' :
                    (template_name === 'stockholm') ? '/api/infra/v1/download/sample-stockholm' : '/api/infra/v1/download/sample-oslo';
        xhr.open('head',url, true);
        xhr.send(null);

        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4 && xhr.status === 200) {
                window.location.href = url;
                logger.info("Download Site: Successful");
            }
            else if (xhr.readyState === 4)
			{
               	this.errorMessage = "Download Site errors:" + xhr.status + ", " + xhr.statusText;
                logger.error(this.errorMessage);
			}
        }

    }

    // Deploy SPA sample
    getDeploy(template_name){
       return this.downloadInfoService.getDeploySite(template_name).then(
            (data) => {
                logger.info("Got Deploy - " + data);

                if (data.status && data.status === 'working'){
                    this.showDeployErrorModal();
                    return 'working';
                }

                this.showDeployStartModal();
                return "deployed";
            },
            (error) => {
                logger.error('Error retrieving deploy service: ' + error);
                this.showDeployErrorModal(error);
                return "deployment error";
            }
        );
    }

    // Open the warning modal before deploy/import service is triggered
    showDeployModal(template_name){
        let deployHeader = 'Import your site';

        return this.$translate([deployHeader])
            .then(nls => {
                deployHeader = nls[deployHeader];

            return this.modal.show({
                options: {
                    headerText: deployHeader,
                    showActionButton: true,
                    actionButtonText: "Import",
                    showCloseButton: true
                },
                settings: {
                    type: "warning"
                },
                data: {
                    text: "This action will delete all your content in your tenant. Do you want to continue?"
                }
            }).then( result => {
                this.getDeploy(template_name);
                return 'success';
            })
        }).catch(err => {
            if (err && err !== 'cancel' && err !== 'backdrop click') {
                logger.error(err);
                return 'error';
            }
        });
    }

    // Open the error modal when deploy/import service returned error
    showDeployErrorModal(msg){
        let errorHeader = 'Import error';
        let errorMsg = (msg === undefined) ? "Acoustic Content is importing our newest site template into your tenant now!" : msg;

        return this.$translate([errorHeader])
            .then(nls => {
                errorHeader = nls[errorHeader];

               return this.modal.show({
                    options: {
                        headerText: errorHeader,
                        showActionButton: false,
                        showCloseButton: false
                    },
                    settings: {
                        type: "error"
                    },
                    data: {
                        text: errorMsg
                    }
                }).then( res=>{
                    return 'success';
               });
            }).catch(err => {
            if (err && err !== 'cancel' && err !== 'backdrop click') {
                logger.error(err);
                return 'error';
            }
        });
    }


    // Open the error modal when deploy/import service is busy
    showDeployStartModal(){
        let msgHeader = 'Import is started';

        return this.$translate([msgHeader])
            .then(nls => {
                msgHeader = nls[msgHeader];

                return this.modal.show({
                    options: {
                        headerText: msgHeader,
                        showActionButton: false,
                        showCloseButton: false
                    },
                    settings: {
                        type: "confirmation"
                    },
                    data: {
                        text: "The import service is started. It may take up to 20 minutes to be finished."
                    }
                }).then( res =>{
                    return 'success';
                });
            }).catch(err => {
                if (err && err !== 'cancel' && err !== 'backdrop click') {
                    logger.error(err);
                    return 'error';
                }
            });
    }


    // Show the date in different formats based on the locale you choose in both CUI and Browser
    _getLocaleDateString(date) {
        if ( !date || date === "Invalid Date")
        {
            return null;
        }
	    const currentLocale = this.homepageUtil.getCurrentLocale().replace('_', '-');
        const options = {year: 'numeric', month: '2-digit', day: '2-digit' };

        return date.toLocaleString(currentLocale, options);
    }



};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "downloadInfoService","$translate", "homepageUtil", "tenantRegistryService", "x1Modal", "shellUtil", downloadAssetsController]
};



// WEBPACK FOOTER //
// ./app/components/downloadSite/downloadSite.component.js